import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ABAS_GLOBAIS } from '@/features/cadastros/abas';
import { CadastrosGlobais } from '@/features/cadastros/componentes/CadastrosGlobais';
import { rotaDaPlataforma } from '@/features/permissoes/guardas';

const busca = z.object({
  aba: z.enum(ABAS_GLOBAIS).default('equipamentos').catch('equipamentos'),
  busca: z.string().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

/** Cadastros globais: equipamentos e grupos musculares (spec 014, CA-05). */
export const Route = createFileRoute('/_autenticado/plataforma/cadastros')({
  ...rotaDaPlataforma('Cadastros globais'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { aba, busca: texto, cursor } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CadastrosGlobais
      aba={aba}
      filtros={{ busca: texto, cursor }}
      aoMudarAba={(nova) => {
        void navigate({ search: { aba: nova }, replace: true });
      }}
      aoMudarFiltros={(filtros) => {
        void navigate({ search: { aba, ...filtros }, replace: true });
      }}
    />
  );
}
